import React from 'react';
import {FormControl, FormHelperText, InputLabel, MenuItem, Select} from "material-ui";

export const renderSelectField = ({
                                      input,
                                      meta: {touched, error},
                                      ...custom
                                  }) => (

    <FormControl fullWidth
                 margin="normal"
                 error={custom.err !== undefined && custom.err !== null}>
        <InputLabel>{custom.label}</InputLabel>
        <Select
            {...input}
            {...custom}>
            {custom.data.map(n => {
                return <MenuItem key={n.id} value={n.id}>{n.name}</MenuItem>
            })}
        </Select>
        {custom.err !== undefined && custom.err !== null ?
            custom.err.map((n, i) =>
                <FormHelperText key={i}>{n}</FormHelperText>) : null}
    </FormControl>
);


// WEBPACK FOOTER //
// ./src/forms/inputs/SelectField.js